import { useMemo } from 'react';
import useToken from '../useToken';

export type UseAuthenticationTypes = {
  authenticated: string;
  token: string;
};

function useAuthentication(): UseAuthenticationTypes {
  const { token } = useToken();

  const authenticated = useMemo(() => token, [token]);

  return {
    authenticated,
    token,
  };
}

export default useAuthentication;
